// Qiita 投稿一覧取得
const requests = {
  getPostsInfo: `/api/v2/authenticated_user/items`,
};

export default requests;